import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconYen"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.59407 6.58892L7.08892 7.90593L10.6712 12H9V14H11V18H13V14H15V12H13.3288L16.9111 7.90593L15.4059 6.58892L12 10.4814L8.59407 6.58892Z" fill="currentColor"/></CentralIconBase>;
});

export default IconYen;
